import {TabBody} from "../../../tab-content";
import {ManagedTab} from "../../../managed-tabs";
import "./OperationalOverviewTab.scss";
import {useOperationalEntity} from "../../context";
import {OperationalDetailsColumn} from "./OperationalDetailsColumn";
import {useRecentlyViewedOperationalEntities} from "../../../hooks";
import {useEffect} from "react";
import {OperationalBoidsColumn} from "../../boids";
import {HistoryTabColumn} from "../../history";
import {useFlags} from "launchdarkly-react-client-sdk";

export const OperationalOverviewTab: ManagedTab = () => {
  const {
    entity: {id}
  } = useOperationalEntity();
  const {addBrowsedOperationalEntity} = useRecentlyViewedOperationalEntities();
  const flags = useFlags();

  useEffect(() => addBrowsedOperationalEntity(id), [id]);

  return (
    <TabBody name={"overview"}>
      <OperationalDetailsColumn />
      <OperationalBoidsColumn />
      <HistoryTabColumn id={id} />
    </TabBody>
  );
};
